module.exports = __webpack_public_path__ + "img/c08c85b9f4df9573116ae393d6292ab9.c361ad2d.jpg";